// Funciones puras sobre "qué tan reciente es una entrada del changelog", sin
// localStorage ni React. Separado de changelogSeenStorage.js (que sí hace
// I/O) siguiendo el mismo criterio que folioMatrixLogic.js/bulkEditLogic.js
// en este proyecto: la lógica se prueba con node, el I/O se prueba a mano.

export const DEFAULT_NOVELTY_WINDOW_DAYS = 30;

const MS_POR_DIA = 24 * 60 * 60 * 1000;

// true si "entry.date" cayó dentro de los últimos "days" días, contados
// desde "ahora" (Date, por defecto la fecha real — se puede inyectar para
// pruebas). Los indicadores de "Nuevo" dejan de mostrarse después de esto,
// aunque el usuario nunca los haya marcado como vistos.
export function isWithinNoveltyWindow(entry, days = DEFAULT_NOVELTY_WINDOW_DAYS, ahora = new Date()) {
  if (!entry || !entry.date) return false;
  const fechaEntry = new Date(`${entry.date}T00:00:00`);
  if (Number.isNaN(fechaEntry.getTime())) return false;
  const diffDias = (ahora.getTime() - fechaEntry.getTime()) / MS_POR_DIA;
  return diffDias >= 0 && diffDias <= days;
}

// De una lista de entradas (ej. las que aplican a un mismo anchor), la más
// reciente por fecha. Usado para decidir qué contenido mostrar en el
// tooltip cuando más de una entrada apunta al mismo lugar de la interfaz.
export function entradaMasReciente(entries) {
  if (!entries || entries.length === 0) return null;
  return [...entries].sort((a, b) => b.date.localeCompare(a.date))[0];
}
